import React from 'react'
import Layout from './src/components/templates/Layout'
import './src/style/style.css'

export const wrapPageElement = ({ element, props }) => {
    return <Layout {...props}>{element}</Layout>
  }
